// Nibro authoritative DN / Inch / D1 mm table (mirrors backend
// seed_data.SIZE_TABLE — May 2026). One canonical entry per DN.
export const SIZE_TABLE = [
  { dn: 10,  inch: null,       d1_mm: 12.0 },
  { dn: 15,  inch: '3/8"',     d1_mm: 18.0 },
  { dn: 20,  inch: '1/2"',     d1_mm: 22.0 },
  { dn: 25,  inch: null,       d1_mm: 28.0 },
  { dn: 32,  inch: '1"',       d1_mm: 33.7 },
  { dn: 40,  inch: '1 1/2"',   d1_mm: 48.3 },
  { dn: 50,  inch: '2"',       d1_mm: 60.3 },
  { dn: 65,  inch: '2 1/2"',   d1_mm: 76.1 },
  { dn: 80,  inch: '3"',       d1_mm: 88.9 },
  { dn: 100, inch: '4"',       d1_mm: 114.3 },
  { dn: 125, inch: '5"',       d1_mm: 139.7 },
  { dn: 150, inch: '6"',       d1_mm: 168.3 },
  { dn: 200, inch: '8"',       d1_mm: 219.1 },
  { dn: 250, inch: '10"',      d1_mm: 273.0 },
  { dn: 300, inch: '12"',      d1_mm: 323.9 },
  { dn: 350, inch: '14"',      d1_mm: 354.0 },
  { dn: 400, inch: '16"',      d1_mm: 406.0 },
  { dn: 450, inch: '18"',      d1_mm: 456.0 },
  { dn: 520, inch: '20"',      d1_mm: 506.0 },
  { dn: 550, inch: '22"',      d1_mm: 556.0 },
  { dn: 600, inch: '24"',      d1_mm: 606.0 },
  { dn: 700, inch: '28"',      d1_mm: 708.0 },
  { dn: 800, inch: '32"',      d1_mm: 812.8 },
  { dn: 900, inch: '36"',      d1_mm: 914.4 },
];

export function convertFromMm(mm) {
  if (mm == null || isNaN(mm)) return null;
  const v = parseFloat(mm);
  return SIZE_TABLE.reduce((best, e) =>
    Math.abs(e.d1_mm - v) < Math.abs(best.d1_mm - v) ? e : best, SIZE_TABLE[0]);
}
export function convertFromDn(dn) {
  return SIZE_TABLE.find((e) => e.dn === parseInt(dn)) || null;
}
export function convertFromInch(inch) {
  if (!inch) return null;
  const norm = String(inch).replace(/\s/g, "").replace(/"/g, "");
  return SIZE_TABLE.find(
    (e) => e.inch && e.inch.replace(/\s/g, "").replace(/"/g, "") === norm,
  ) || null;
}
